import React, { ReactNode } from 'react';
import {
  createReducer,
  createStore,
  Provider as PRProvider,
} from 'react-principal';
import { persistkeys } from '../constants';
import AsyncStorage from '@react-native-async-storage/async-storage';

const SET_FCM = 'SET_FCM';
const CLEAR = 'CLEAR';

interface InitialState {
  fcm: string;
}

const initialState: InitialState = {
  fcm: '',
};

const reducer = createReducer<InitialState>({
  SET_FCM: (state, { payload: { fcm } }) => ({
    ...state,
    fcm,
  }),
  CLEAR: (state, {}) => ({
    ...state,
    fcm: '',
  }),
});

function setFcm(fcm: string) {
  return {
    type: SET_FCM,
    payload: { fcm },
  };
}

function deleteFcm() {
  return {
    type: CLEAR,
    payload: {},
  };
}

const storeFcm = createStore({
  reducer,
  initialState,
  persistKey: persistkeys.FCM,
  storage: AsyncStorage,
  mapStateToPersist: ({ fcm }) => ({
    fcm,
  }),
});

const mapFcmPersistToState = () => storeFcm.setToState();

const getFcmFromPersist = () => storeFcm.state.fcm;

const FcmProvider = ({ children }: { children: ReactNode }) => {
  return <PRProvider {...{ store: storeFcm }}>{children}</PRProvider>;
};

export {
  initialState as initialStateFcm,
  reducer as reducerFcm,
  setFcm,
  FcmProvider,
  storeFcm,
  mapFcmPersistToState,
  getFcmFromPersist,
  deleteFcm,
};
